import { StandardProps } from "@/components/componentMap";
import styles from "./PriceUnitPriceAndRating.module.scss";
import { Price } from "@/components/Price/Price";
import { UnitPrice } from "@/components/UnitPrice/UnitPrice";
import { RatingAndReviews } from "@/components/RatingAndReviews/RatingAndReviews";

export function PriceUnitPriceAndRating({
  product,
  configProps,
  flags,
  runtimeConfig,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "configProps" | "flags" | "runtimeConfig" | "experiencesRawObject"
>) {
  return (
    <div className={styles.wrapper}>
      {/*** include components here ***/}
      <div className={styles.priceAndUnitPrice}>
        <Price
          product={product}
          configProps={configProps}
          flags={flags}
          runtimeConfig={runtimeConfig}
          experiencesRawObject={experiencesRawObject}
        />
        <UnitPrice product={product} flags={flags} />
      </div>
      <RatingAndReviews
        product={product}
        configProps={configProps}
        flags={flags}
      />
    </div>
  );
}
